import { render } from "./Tenants.vue?vue&type=template&id=efaac08e"
import script from "./Tenants.vue?vue&type=script&lang=js"
export * from "./Tenants.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/Admin/Tenants/Tenants.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "efaac08e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('efaac08e', __exports__)) {
    api.reload('efaac08e', __exports__)
  }
  
  module.hot.accept("./Tenants.vue?vue&type=template&id=efaac08e", () => {
    api.rerender('efaac08e', render)
  })

}


export default __exports__